export default __webpack_public_path__ + "maps-examples-light-example-thumbnail-960-1e6d9f19efe361edefcd5f2d58e5f97e.webp";